var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questionTaskRecord" },
    [
      _vm.baseInfo.status === 3
        ? _c("div", { staticClass: "questionTaskRecord_mask" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-notice-bar",
        {
          attrs: { mode: "closeable", background: "#333333", color: "#ffffff" }
        },
        [_vm._v(_vm._s(_vm.baseInfo.title))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "questionTaskRecord_title" }, [
        _vm._v("导师任务说明：")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "questionTaskRecord_topic" }, [
        _c("div", { staticClass: "questionTaskRecord_topic_word" }, [
          _vm._v("\n\t\t\t正文内容：\n\t\t\t"),
          _c("br"),
          _vm._v("\n\t\t\t" + _vm._s(_vm.baseInfo.description) + "\n\t\t\t"),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "questionTaskRecord_topic_attachment" },
            [
              _vm._v("\n\t\t\t\t附件下载：\n\t\t\t\t"),
              _vm._l(_vm.baseInfo.bookAttachments, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: { "margin-right": ".12rem" },
                    attrs: { href: item.url },
                    on: {
                      click: function() {
                        return _vm.handleDownloadUrl(
                          item.id,
                          item.name,
                          "teacher"
                        )
                      }
                    }
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      [
        _c("div", { staticClass: "questionTaskRecord_title" }, [
          _vm._v("提交的任务：")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "questionTaskRecord_reply" }, [
          _c(
            "div",
            { staticClass: "questionTaskRecord_reply_word" },
            [
              _c("van-field", {
                attrs: {
                  placeholder: "请填写",
                  rows: "5",
                  autosize: "",
                  type: "textarea",
                  disabled: _vm.computedStudent(
                    _vm.roleName,
                    _vm.baseInfo.status
                  )
                },
                model: {
                  value: _vm.attachmentComment,
                  callback: function($$v) {
                    _vm.attachmentComment = $$v
                  },
                  expression: "attachmentComment"
                }
              })
            ],
            1
          )
        ])
      ],
      _vm._v(" "),
      _c("div", { staticClass: "questionTaskRecord_title" }, [
        _vm._v("附件：")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "questionTaskRecord_uploads" },
        [
          _vm.baseInfo.status <= 1 && _vm.fileList.length <= 6
            ? _c(
                "van-uploader",
                {
                  attrs: {
                    "preview-image": false,
                    "max-count": 6,
                    "after-read": _vm.uploadImage,
                    "preview-full-image": false,
                    accept: _vm.accept
                  },
                  on: { oversize: _vm.oversize }
                },
                [
                  _c(
                    "van-button",
                    {
                      staticStyle: { margin: ".1rem 0" },
                      attrs: {
                        icon: "plus",
                        color: "#3F9EFF",
                        type: "primary",
                        size: "small"
                      }
                    },
                    [_vm._v("上传文件")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "12px",
                color: "#999",
                "margin-top": "8px"
              }
            },
            [
              _vm._v(
                "\n\t\t\t支持：" +
                  _vm._s(_vm.accept) +
                  "，文件大小应小于200MB。\n\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _vm.baseInfo.status <= 1
            ? _c(
                "div",
                { staticClass: "questionTaskRecord_uploads_list" },
                _vm._l(_vm.fileList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "questionTaskRecord_uploads_item"
                    },
                    [
                      _vm._v("\n\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t"),
                      _c("van-icon", {
                        attrs: {
                          name: "clear",
                          size: ".18rem",
                          color: "#c32929"
                        },
                        on: {
                          click: function() {
                            return _vm.handleRemove(index)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticClass: "questionTaskRecord_uploads_list" },
                _vm._l(_vm.baseInfo.attachments, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "questionTaskRecord_uploads_item",
                      attrs: { href: item.attachmentAddress },
                      on: {
                        click: function() {
                          return _vm.handleDownloadUrl(
                            item.id,
                            item.name,
                            "student"
                          )
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t")]
                  )
                }),
                0
              )
        ],
        1
      ),
      _vm._v(" "),
      _vm.computedShowBtn(_vm.baseInfo.status)
        ? _c("div", { staticClass: "questionTaskRecord_btns" }, [
            _c(
              "div",
              {
                staticClass: "questionTaskRecord_btns_cancel",
                on: { click: _vm.handleBack }
              },
              [_vm._v("\n\t\t\t取消\n\t\t")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "questionTaskRecord_btns_confirm",
                on: {
                  click: function() {
                    return _vm.handleSubmit()
                  }
                }
              },
              [_vm._v("\n\t\t\t提交\n\t\t")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e0a29a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0a29a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/question/task/record/index.vue
// module id = null
// module chunks = 